import styles from "./index.module.scss";
import { createPortal } from "react-dom";
import { useEffect } from "react";
import clsx from "clsx";
import CrossIcon from "../../assets/icons/crossIcon.svg";

export interface IModalProps {
  isOpen: boolean;
  setStatus?: () => void;
  children: React.ReactNode;
  className?: string;
  modalClassName?: string;
}

const Modal: React.FC<IModalProps> = ({
  isOpen,
  setStatus = () => {
    let name;
  },
  children,
  className,
  modalClassName,
}) => {
  const modalContainer = document.getElementById("modal")!;
  const changeStatus = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as Element;
    if (target.classList.contains(styles.modal)) {
      setStatus();
    }
  };

  useEffect(() => {
    isOpen
      ? document.body.classList.add(styles["overflow-hidden"])
      : document.body.classList.remove(styles["overflow-hidden"]);
    return () => {
      document.body.classList.remove(styles["overflow-hidden"]);
    };
  }, [isOpen]);

  return createPortal(
    <dialog
      onClick={changeStatus}
      className={clsx(
        isOpen ? `${styles.modal} ${styles.active}` : `${styles.modal}`,
        className
      )}
    >
      <div className={styles["modal__content-container"]}>
        <div
          className={clsx(`${styles.modal__content}`, modalClassName)}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <img className={styles.cross_icon} src={CrossIcon} alt="cross" onClick={setStatus}/>
          {isOpen && children}
        </div>
      </div>
    </dialog>,
    modalContainer
  );
};

export default Modal;
